import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Template from "../../components/template"
import { fetchJobDetails } from "./service";
import Map from "./components/Map";
import Loader from "../../components/loading";
import ServiceCategory from "./components/ServiceCategory";
import JobSummary from "./components/JobSummary";
import FtmDetails from "./components/FtmDetails";
import CustomerDetails from "./components/CustomerDetails";
import CostStatus from "./components/CostStatus";
import JobStatus from "./components/JobStatus";
import BillingInformation from "./components/BillingInformation";
import Transactions from "./components/Transactions";
import FtmCheckInVerification from "./components/FtmCheckInVerification";
import JobImages from "./components/JobImages";
import NavBtn from "./components/NavBtn";

const JobDetails = () => {
    const { job_id } = useParams();
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState(null);

    useEffect(() => {
        const getJobDetails = async () => {
            try {
                setLoading(true);
                const response = await fetchJobDetails(job_id);
                if (response.status === "Success") {
                    setDetails({
                        job: response.data.job,
                        ftm_to_customer_cost: response.data.ftm_to_customer_cost,
                        instafix_to_customer_cost: response.data.instafix_to_customer_cost,
                    });
                }
            } catch (error) {
                console.log("Job details error : ", error);
            } finally {
                setLoading(false);
            }
        };

        getJobDetails();
    }, [job_id]);

    if (loading) {
        return <Loader />;
    }

    return (
        <Template>
            <div className="container-fluid py-2">
                <div className="row mt-4">
                    <div className="col-xl-7">
                        <div className="card h-100">
                            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <Map job_id={job_id} />
                            </div>
                            <div className="card-body d-flex p-3 mt-2">
                                <h6 className="my-auto">#{job_id}</h6>
                                <NavBtn job_id={job_id} job_firebase_document_id={details?.job?.job_firebase_document_id}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 ms-auto mt-xl-0 mt-5">
                        <div className="card h-100">
                            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                <ServiceCategory sub_skill={details?.job?.sub_skill} current_status={details?.job?.job_status_details} />
                            </div>
                            <div className="card-body p-3">
                                <JobSummary job={details?.job} />
                            </div>
                        </div>
                    </div>
                </div>

                <CostStatus
                    ftm_to_customer_cost={details?.ftm_to_customer_cost}
                    instafix_to_customer_cost={details?.instafix_to_customer_cost?.totalCost}
                    booking_fee={details?.job?.job_booking_fee}
                    call_out_fee={details?.job?.job_call_out_fee}
                    rate_per_hour={details?.job?.job_rate_per_hour}
                    working_hours={details?.job?.ftm?.ftm_working_hours}
                />

                <div className="row mt-4">
                    <div className="col-lg-6">
                        <CustomerDetails customer={details?.job.customer} />
                    </div>
                    <div className="col-lg-6 mt-4 mt-lg-0">
                        {details?.job.ftm && <FtmDetails ftm={details?.job.ftm} />}
                    </div>
                </div>

                {/* <hr className="horizontal dark my-5" /> */}

                <div className="row mt-4">
                    <div className="col-lg-4 col-12">
                        <BillingInformation
                            job_id={job_id}
                            tradesperson_fee={{
                                payment_minutes: details?.job?.tradesperson_charges_details?.payment_minutes,
                                working_minutes: details?.job?.tradesperson_charges_details?.working_minutes,
                                ftm_fee: details?.job?.tradesperson_charges_details?.ftm_fee,
                                materials_cost: details?.job?.tradesperson_charges_details?.materials_cost,
                                materials_company_commission: details?.job?.tradesperson_charges_details?.materials_company_commission,
                                total_cost: details?.job?.tradesperson_charges_details?.total_cost,
                                job_discount: details?.job?.tradesperson_charges_details?.job_discount,
                            }}

                            instafix_fee={{
                                booking_fee: details?.job?.job_fix_charges?.fix_charges?.job_booking_fee,
                                call_out_fee: details?.job?.job_fix_charges?.fix_charges?.job_call_out_fee,
                                vat: details?.job?.job_fix_charges?.fix_charge_vat,
                                total: details?.job?.job_fix_charges?.total_fix_charge_with_vat
                            }}
                        />
                    </div>
                    <div className="col-lg-4 col-12 mt-md-0 mt-4">
                        <Transactions payments={details?.job?.payments} />
                    </div>

                    <div className="col-lg-4 col-12 mt-md-0 mt-4">
                        {details?.job.ftm?.ftm_check_in_verification && <FtmCheckInVerification verificationData={details?.job.ftm?.ftm_check_in_verification} />}
                        <JobImages job_images={details?.job?.job_images} />
                    </div>
                </div>

                <div className="row mt-4">
                    <JobStatus
                        job_id={job_id}
                        job_status={details?.job?.job_status_details}
                        job_is_reschedule_job={details?.job?.job_is_reschedule_job}
                        job_is_express_job={details?.job?.job_is_express_job}
                        job_is_have_customer_signature={details?.job?.job_is_have_customer_signature}
                        job_is_remedial_job={details?.job?.job_is_remedial_job}
                        job_approve_for_another_date={{
                            job_is_approve_for_another_date_job: details?.job?.job_is_approve_for_another_date_job,
                            job_approve_for_another_date_additional_charge: details?.job?.job_approve_for_another_date_additional_charge,
                            job_approve_for_another_date_parent_job_id: details?.job?.job_approve_for_another_date_parent_job_id,
                            approve_for_another_date_job_id: details?.job?.another_date_job?.approve_for_another_date_job_id

                        }}
                    />
                </div>
            </div>
        </Template>
    );
};

export default JobDetails;